
import { Journal } from './Journal'

export class PagedJournalList {
    
    
    pageNo;
    isLastPage;
    
    index;
    
    journals;
    
    //Construct from the backend Json Response
    constructor(json) {
        if (json) {
            this.isLastPage = json.last; 
            this.pageNo = json.pageNo; 
            this.index = json.index;
            
            if (json.items)
                this.journals = json.items.map(j => new Journal(j));
            else
                this.journals = [];
        }  
    } 
    
    isFirst = () => {
        return this.pageNo === 0;
    }
    
    isLast = () => {
        return this.isLastPage;
    }
    
}